import AccountEditWrapper from './AccountEditWrapper.component';

export default AccountEditWrapper;